/**
 * 通用接口 - 上传等
 */
const BASE = (import.meta.env.VITE_API_BASE || import.meta.env.VITE_BASE_URL || '').replace(
  /\/$/,
  '',
);
const API_BASE = BASE ? (BASE.includes('/api') ? BASE : BASE + '/api') : '/api';

/** 图片上传响应 */
export interface UploadImageResponse {
  path: string;
  url: string;
}

/** 上传接口 URL - 用于 el-upload action，POST multipart/form-data，参数 file */
export function getUploadUrl(): string {
  return `${API_BASE}/upload`;
}

/** 支持的图片扩展名 */
export const UPLOAD_IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp'] as const;

/** 支持的图片 MIME */
export const UPLOAD_IMAGE_MIMES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'] as const;

/** 文件选择框 accept 值，限制仅可选 jpg/png/gif/webp */
export const UPLOAD_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp';

/** 最大文件大小 10MB */
export const UPLOAD_IMAGE_MAX_SIZE = 10 * 1024 * 1024;
